// extracted by mini-css-extract-plugin
export default {"loading":"FullscreenLoader_loading__ktVnA"};